import {
  Flex, Grid, GridItem, Icon, IconButton, Text,
} from "@chakra-ui/react";
import { MdEdit, MdDelete, MdRemoveRedEye } from "react-icons/md";
import { FcFile } from "react-icons/fc";
import Helper from "../../../utils/Helper";

export default function File({ Item, OnChange }) {
  return (
    <Grid 
      templateColumns={"repeat(12, 1fr)"} 
      alignItems="center" 
      w="100%" 
      p={2} 
      borderRadius="md" 
      // UPDATED: All colors are now using CSS variables via the sx prop
      sx={{
        _hover: { bg: 'var(--fm-item-hover-bg)' }
      }}
    >
      <GridItem colSpan={{ base: 12, md: 5 }} as={Flex} alignItems="center">
        <Icon as={FcFile} boxSize="1.5rem" mr={3} />
        <Text noOfLines={1} fontSize="sm">{Item.OriginalName}</Text>
      </GridItem>
      
      <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
        <Text fontSize="xs" sx={{ color: 'var(--fm-item-meta-text)' }}>
          {Helper.FormatBytes(Item.FileSize)}
        </Text>
      </GridItem>
      
      <GridItem colSpan={2} textAlign="center" display={{ base: 'none', md: 'block' }}>
        <Text fontSize="xs" sx={{ color: 'var(--fm-item-meta-text)' }}>
          {Helper.HandleChatDate(Item.FileUpdatedAt || Item.FileCreatedAt)}
        </Text>
      </GridItem>

      <GridItem as={Flex} colSpan={{ base: 12, md: 3 }} justify="end" gap={1}>
       
        <IconButton 
            size="sm" 
            variant="ghost" 
            icon={<MdEdit />} 
            aria-label="Rename file" 
            onClick={() => OnChange({ Tab: "EditFile", FileId: Item.FileId, FileName: Item.OriginalName, IsOpen: true })}
            sx={{
              color: 'var(--fm-item-icon-btn-color)',
              _hover: { color: 'var(--fm-item-icon-btn-hover-color)' }
            }}
        />
        <IconButton 
            size="sm" 
            variant="ghost" 
            icon={<MdDelete />} 
            aria-label="Delete file" 
            onClick={() => OnChange({ Tab: "DeleteFile", FileId: Item.FileId, IsOpen: true })}
            sx={{
              color: 'var(--fm-item-icon-btn-danger-color)',
              _hover: { 
                color: 'var(--fm-item-icon-btn-danger-hover-color)', 
                bg: 'var(--fm-item-icon-btn-danger-hover-bg)' 
              }
            }}
        />
         <IconButton 
            size="sm" 
            variant="ghost" 
            icon={<MdRemoveRedEye />} 
            aria-label="View file" 
            onClick={() => OnChange({ Tab: "ViewFile", File: Item, IsOpen: true })}
            sx={{
              color: 'var(--fm-item-icon-btn-color)',
              _hover: { color: 'var(--fm-item-icon-btn-hover-color)' }
            }}
        />
      </GridItem>
    </Grid>
  );
}